<template>
  <div class="my-4 grid grid-cols-3 items-center">
    <h2 class="col-span-2 text-left text-1lg leading-tight text-dark-gray">
      {{ title }}
    </h2>
    <button-main
      v-if="showButton"
      variant="secondary"
      size="md"
      class="group flex max-w-max items-center justify-self-end text-1lg text-gray-over-dark md:hidden"
      @click="$router.push('/dispatcher/add-carriers')"
    >
      Add
      <svg
        class="ml-2 h-5 w-5 fill-current text-gray-over-dark group-hover:text-body-color group-focus:text-dark-gray"
        viewBox="0 0 24 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 23L12 7"
          stroke="currentColor"
          stroke-width="3"
        />
        <path
          d="M20 15L4 15"
          stroke="currentColor"
          stroke-width="3"
        />
      </svg>
    </button-main>
    <button-main
      v-if="showButton"
      variant="secondary"
      size="md"
      class="group hidden max-w-max items-center justify-self-end text-1lg text-gray-over-dark md:flex"
      @click="$router.push('/dispatcher/add-carriers')"
    >
      Add a Carrier
      <svg
        class="ml-2 h-5 w-5 fill-current text-gray-over-dark group-hover:text-body-color group-focus:text-dark-gray"
        viewBox="0 0 24 30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 23L12 7"
          stroke="currentColor"
          stroke-width="3"
        />
        <path
          d="M20 15L4 15"
          stroke="currentColor"
          stroke-width="3"
        />
      </svg>
    </button-main>
  </div>
</template>
<script>
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'MyCarriersSubheader',
  components: {
    ButtonMain,
  },
  props: {
    title: {
      type: String,
      require: true,
      default: '',
    },
    showButton: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {};
  },
};
</script>
